import axios from './config/config'
const defaultRoute = 'pedido/'
export default{
    list:(type)=>{
        return axios.get(`${defaultRoute}`)
    },

    update: (id, pedido) => {   
        return axios.put(defaultRoute+id, pedido)
    }
} 
